import { Link } from "react-router-dom";
import { ApiSessionProbe } from "../ApiSessionProbe";

export function Dashboard() {
  return (
    <div>
      <p className="sd-kicker">Dashboard</p>
      <h1 className="sd-h1">Operations overview</h1>
      <p className="sd-lead">
        Navigation, auth, and API connectivity. Tenant and integration screens link from the sidebar — you are signed in
        to this shell.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: "1rem",
          marginBottom: "2rem",
        }}
      >
        <Link to="/tenants" className="sd-main-card" style={{ color: "inherit", textDecoration: "none" }}>
          <div style={{ fontSize: "0.75rem", color: "var(--sd-muted)", marginBottom: "0.35rem" }}>Registry</div>
          <div style={{ fontWeight: 600, fontSize: "1.05rem" }}>Tenants</div>
          <div style={{ fontSize: "0.8rem", color: "var(--sd-muted)", marginTop: "0.5rem" }}>
            Platform Admin — live API
          </div>
        </Link>
        <Link to="/tenant-access" className="sd-main-card" style={{ color: "inherit", textDecoration: "none" }}>
          <div style={{ fontSize: "0.75rem", color: "var(--sd-muted)", marginBottom: "0.35rem" }}>RBAC</div>
          <div style={{ fontWeight: 600, fontSize: "1.05rem" }}>Tenant access</div>
          <div style={{ fontSize: "0.8rem", color: "var(--sd-muted)", marginTop: "0.5rem" }}>
            Customer admin / operator per tenant
          </div>
        </Link>
        <Link to="/users" className="sd-main-card" style={{ color: "inherit", textDecoration: "none" }}>
          <div style={{ fontSize: "0.75rem", color: "var(--sd-muted)", marginBottom: "0.35rem" }}>RBAC</div>
          <div style={{ fontWeight: 600, fontSize: "1.05rem" }}>Platform users</div>
          <div style={{ fontSize: "0.8rem", color: "var(--sd-muted)", marginTop: "0.5rem" }}>
            Admin / viewer roles (D1)
          </div>
        </Link>
        <Link
          to="/integrations"
          className="sd-main-card"
          style={{ color: "inherit", textDecoration: "none" }}
        >
          <div style={{ fontSize: "0.75rem", color: "var(--sd-muted)", marginBottom: "0.35rem" }}>Telephony</div>
          <div style={{ fontWeight: 600, fontSize: "1.05rem" }}>Wildix</div>
          <div style={{ fontSize: "0.8rem", color: "var(--sd-muted)", marginTop: "0.5rem" }}>
            Webhooks & PBX wizard (next)
          </div>
        </Link>
      </div>

      <div style={{ marginTop: "0.5rem" }}>
        <p className="sd-kicker" style={{ marginBottom: "0.75rem" }}>
          Developer — session probe
        </p>
        <ApiSessionProbe />
      </div>
    </div>
  );
}
